export const API_BASE_URL = 'https://dndplayground.ru/api';
export const HOST_BASE_URL = 'https://dndplayground.ru'
